import { createReactWrapper } from '@iress/ids-create-react-wrapper';
import { defineIDS } from './define-ids';
import { suffix } from './tag-suffix';
defineIDS({
    suffix,
});
// IressButtonGroup
const IressButtonGroup = createReactWrapper('iress-button-group-24866', false, suffix);
IressButtonGroup.displayName = 'IressButtonGroup';
export { IressButtonGroup };
// END IressButtonGroup
// IressFilter
import { PopperAlign, } from './component.types';
;
const IressFilter = createReactWrapper('iress-filter-24866', false, suffix);
IressFilter.displayName = 'IressFilter';
IressFilter.Align = PopperAlign;
export { IressFilter };
// END IressFilter
// IressToggle
import { ToggleLayout, } from './component.types';
;
const IressToggle = createReactWrapper('iress-toggle-24866', false, suffix);
IressToggle.displayName = 'IressToggle';
IressToggle.Layout = ToggleLayout;
export { IressToggle };
// END IressToggle
// IressExpander
import { ExpanderSlot, ExpanderMode, } from './component.types';
;
const IressExpander = createReactWrapper('iress-expander-24866', false, suffix);
IressExpander.displayName = 'IressExpander';
IressExpander.Slot = ExpanderSlot;
IressExpander.Mode = ExpanderMode;
export { IressExpander };
// END IressExpander
// IressSlider
const IressSlider = createReactWrapper('iress-slider-24866', false, suffix);
IressSlider.displayName = 'IressSlider';
export { IressSlider };
// END IressSlider
// IressNavbar
import { NavbarHorizontalAlign, Breakpoint, PaddingSize, NavbarSlot, } from './component.types';
;
const IressNavbar = createReactWrapper('iress-navbar-24866', false, suffix);
IressNavbar.displayName = 'IressNavbar';
IressNavbar.HorizontalAlign = NavbarHorizontalAlign;
IressNavbar.Breakpoint = Breakpoint;
IressNavbar.Padding = PaddingSize;
IressNavbar.Slot = NavbarSlot;
export { IressNavbar };
// END IressNavbar
// IressCombobox
import { ComboboxSlot, InputWidth, DisplayMode, } from './component.types';
;
const IressCombobox = createReactWrapper('iress-combobox-24866', false, suffix);
IressCombobox.displayName = 'IressCombobox';
IressCombobox.Slot = ComboboxSlot;
IressCombobox.Width = InputWidth;
IressCombobox.DisplayMode = DisplayMode;
export { IressCombobox };
// END IressCombobox
// IressHide
const IressHide = createReactWrapper('iress-hide-24866', false, suffix);
IressHide.displayName = 'IressHide';
export { IressHide };
// END IressHide
// IressSkeleton
import { SkeletonMode, TextVariant, } from './component.types';
;
const IressSkeleton = createReactWrapper('iress-skeleton-24866', false, suffix);
IressSkeleton.displayName = 'IressSkeleton';
IressSkeleton.Mode = SkeletonMode;
IressSkeleton.TextVariant = TextVariant;
export { IressSkeleton };
// END IressSkeleton
// IressOverlayPanel
import { OverlayPanelSlot, } from './component.types';
;
const IressOverlayPanel = createReactWrapper('iress-overlay-panel-24866', false, suffix);
IressOverlayPanel.displayName = 'IressOverlayPanel';
IressOverlayPanel.Slot = OverlayPanelSlot;
export { IressOverlayPanel };
// END IressOverlayPanel
// IressPopover
import { PopoverSlot, PopoverType, } from './component.types';
;
const IressPopover = createReactWrapper('iress-popover-24866', false, suffix);
IressPopover.displayName = 'IressPopover';
IressPopover.Slot = PopoverSlot;
IressPopover.Align = PopperAlign;
IressPopover.Type = PopoverType;
export { IressPopover };
// END IressPopover
// IressMenu
import { MenuType, MenuLayout, } from './component.types';
;
const IressMenu = createReactWrapper('iress-menu-24866', false, suffix);
IressMenu.displayName = 'IressMenu';
IressMenu.Type = MenuType;
IressMenu.Layout = MenuLayout;
export { IressMenu };
// END IressMenu
// IressMenuItem
import { HeadingLevel, MenuItemSlot, } from './component.types';
;
const IressMenuItem = createReactWrapper('iress-menu-item-24866', false, suffix);
IressMenuItem.displayName = 'IressMenuItem';
IressMenuItem.HeadingLevel = HeadingLevel;
IressMenuItem.Slot = MenuItemSlot;
export { IressMenuItem };
// END IressMenuItem
// IressSkipLink
const IressSkipLink = createReactWrapper('iress-skip-link-24866', false, suffix);
IressSkipLink.displayName = 'IressSkipLink';
export { IressSkipLink };
// END IressSkipLink
// IressProgress
const IressProgress = createReactWrapper('iress-progress-24866', false, suffix);
IressProgress.displayName = 'IressProgress';
export { IressProgress };
// END IressProgress
// IressToaster
import { ToasterPosition, } from './component.types';
;
const IressToaster = createReactWrapper('iress-toaster-24866', false, suffix);
IressToaster.displayName = 'IressToaster';
IressToaster.Padding = PaddingSize;
IressToaster.Position = ToasterPosition;
export { IressToaster };
// END IressToaster
// IressTable
import { TableColumnAlign, TableScope, TableCellFormat, TableSortOrder, TableSlot, } from './component.types';
;
const IressTable = createReactWrapper('iress-table-24866', false, suffix);
IressTable.displayName = 'IressTable';
IressTable.ColumnAlign = TableColumnAlign;
IressTable.Scope = TableScope;
IressTable.CellFormat = TableCellFormat;
IressTable.SortOrder = TableSortOrder;
IressTable.Slot = TableSlot;
export { IressTable };
// END IressTable
// IressSlideout
import { SlideoutMode, SlideoutPosition, SlideoutSize, SlideoutSlot, } from './component.types';
;
const IressSlideout = createReactWrapper('iress-slideout-24866', false, suffix);
IressSlideout.displayName = 'IressSlideout';
IressSlideout.Mode = SlideoutMode;
IressSlideout.Position = SlideoutPosition;
IressSlideout.Padding = PaddingSize;
IressSlideout.Size = SlideoutSize;
IressSlideout.Slot = SlideoutSlot;
export { IressSlideout };
// END IressSlideout
// IressTabContainer
import { TabContainerLayout, TabContainerSlot, } from './component.types';
;
const IressTabContainer = createReactWrapper('iress-tab-container-24866', false, suffix);
IressTabContainer.displayName = 'IressTabContainer';
IressTabContainer.Layout = TabContainerLayout;
IressTabContainer.Slot = TabContainerSlot;
export { IressTabContainer };
// END IressTabContainer
// IressTabPanel
const IressTabPanel = createReactWrapper('iress-tab-panel-24866', false, suffix);
IressTabPanel.displayName = 'IressTabPanel';
export { IressTabPanel };
// END IressTabPanel
// IressTabButton
const IressTabButton = createReactWrapper('iress-tab-button-24866', false, suffix);
IressTabButton.displayName = 'IressTabButton';
export { IressTabButton };
// END IressTabButton
// IressForm
import { FormSlot, } from './component.types';
;
const IressForm = createReactWrapper('iress-form-24866', false, suffix);
IressForm.displayName = 'IressForm';
IressForm.Slot = FormSlot;
export { IressForm };
// END IressForm
// IressField
import { FieldSlot, } from './component.types';
;
const IressField = createReactWrapper('iress-field-24866', false, suffix);
IressField.displayName = 'IressField';
IressField.Slot = FieldSlot;
export { IressField };
// END IressField
// IressInput
import { TextFieldType, InputMode, InputSlot, } from './component.types';
;
const IressInput = createReactWrapper('iress-input-24866', false, suffix);
IressInput.displayName = 'IressInput';
IressInput.Type = TextFieldType;
IressInput.Width = InputWidth;
IressInput.InputMode = InputMode;
IressInput.Slot = InputSlot;
export { IressInput };
// END IressInput
// IressCheckbox
const IressCheckbox = createReactWrapper('iress-checkbox-24866', false, suffix);
IressCheckbox.displayName = 'IressCheckbox';
export { IressCheckbox };
// END IressCheckbox
// IressCheckboxMark
const IressCheckboxMark = createReactWrapper('iress-checkbox-mark-24866', false, suffix);
IressCheckboxMark.displayName = 'IressCheckboxMark';
export { IressCheckboxMark };
// END IressCheckboxMark
// IressCheckboxGroup
import { CheckboxGroupLayout, } from './component.types';
;
const IressCheckboxGroup = createReactWrapper('iress-checkbox-group-24866', false, suffix);
IressCheckboxGroup.displayName = 'IressCheckboxGroup';
IressCheckboxGroup.Layout = CheckboxGroupLayout;
export { IressCheckboxGroup };
// END IressCheckboxGroup
// IressRadio
const IressRadio = createReactWrapper('iress-radio-24866', false, suffix);
IressRadio.displayName = 'IressRadio';
export { IressRadio };
// END IressRadio
// IressRadioGroup
import { RadioGroupLayout, } from './component.types';
;
const IressRadioGroup = createReactWrapper('iress-radio-group-24866', false, suffix);
IressRadioGroup.displayName = 'IressRadioGroup';
IressRadioGroup.Layout = RadioGroupLayout;
export { IressRadioGroup };
// END IressRadioGroup
// IressButton
import { ButtonMode, ButtonType, ButtonSlot, } from './component.types';
;
const IressButton = createReactWrapper('iress-button-24866', false, suffix);
IressButton.displayName = 'IressButton';
IressButton.Mode = ButtonMode;
IressButton.Type = ButtonType;
IressButton.Slot = ButtonSlot;
IressButton.Fluid = Breakpoint;
export { IressButton };
// END IressButton
// IressBadge
import { BadgeMode, BadgeSlot, } from './component.types';
;
const IressBadge = createReactWrapper('iress-badge-24866', false, suffix);
IressBadge.displayName = 'IressBadge';
IressBadge.Mode = BadgeMode;
IressBadge.Slot = BadgeSlot;
export { IressBadge };
// END IressBadge
// IressPanel
import { TextAlign, PanelBackground, } from './component.types';
;
const IressPanel = createReactWrapper('iress-panel-24866', false, suffix);
IressPanel.displayName = 'IressPanel';
IressPanel.Padding = PaddingSize;
IressPanel.TextAlign = TextAlign;
IressPanel.Background = PanelBackground;
export { IressPanel };
// END IressPanel
// IressContainer
const IressContainer = createReactWrapper('iress-container-24866', true, suffix);
IressContainer.displayName = 'IressContainer';
export { IressContainer };
// END IressContainer
// IressCol
import { ColOffset, ColSpan, ColAlignSelf, } from './component.types';
;
const IressCol = createReactWrapper('iress-col-24866', true, suffix);
IressCol.displayName = 'IressCol';
IressCol.Offset = ColOffset;
IressCol.Span = ColSpan;
IressCol.AlignSelf = ColAlignSelf;
export { IressCol };
// END IressCol
// IressRow
import { RowVerticalAlign, RowHorizontalAlign, RowGutter, } from './component.types';
;
const IressRow = createReactWrapper('iress-row-24866', true, suffix);
IressRow.displayName = 'IressRow';
IressRow.VerticalAlign = RowVerticalAlign;
IressRow.HorizontalAlign = RowHorizontalAlign;
IressRow.Gutter = RowGutter;
export { IressRow };
// END IressRow
// IressValidationMessage
import { SystemValidationStatus, ValidationMessageSlot, } from './component.types';
;
const IressValidationMessage = createReactWrapper('iress-validation-message-24866', false, suffix);
IressValidationMessage.displayName = 'IressValidationMessage';
IressValidationMessage.Status = SystemValidationStatus;
IressValidationMessage.Slot = ValidationMessageSlot;
export { IressValidationMessage };
// END IressValidationMessage
// IressValidationSummary
const IressValidationSummary = createReactWrapper('iress-validation-summary-24866', false, suffix);
IressValidationSummary.displayName = 'IressValidationSummary';
export { IressValidationSummary };
// END IressValidationSummary
// IressAlert
import { AlertSlot, } from './component.types';
;
const IressAlert = createReactWrapper('iress-alert-24866', false, suffix);
IressAlert.displayName = 'IressAlert';
IressAlert.Status = SystemValidationStatus;
IressAlert.HeadingLevel = HeadingLevel;
IressAlert.Slot = AlertSlot;
export { IressAlert };
// END IressAlert
// IressIcon
import { IconSet, IconFlip, IconRotate, IconSpin, IconSize, TextMode, } from './component.types';
;
const IressIcon = createReactWrapper('iress-icon-24866', false, suffix);
IressIcon.displayName = 'IressIcon';
IressIcon.Set = IconSet;
IressIcon.Flip = IconFlip;
IressIcon.Rotation = IconRotate;
IressIcon.Spin = IconSpin;
IressIcon.Size = IconSize;
IressIcon.Mode = TextMode;
export { IressIcon };
// END IressIcon
// IressInline
import { InlineGutter, InlineHorizontalAlign, InlineVerticalAlign, } from './component.types';
;
const IressInline = createReactWrapper('iress-inline-24866', false, suffix);
IressInline.displayName = 'IressInline';
IressInline.Gutter = InlineGutter;
IressInline.HorizontalAlign = InlineHorizontalAlign;
IressInline.VerticalAlign = InlineVerticalAlign;
export { IressInline };
// END IressInline
// IressText
import { TextElement, } from './component.types';
;
const IressText = createReactWrapper('iress-text-24866', false, suffix);
IressText.displayName = 'IressText';
IressText.Element = TextElement;
IressText.Variant = TextVariant;
IressText.Align = TextAlign;
IressText.Mode = TextMode;
export { IressText };
// END IressText
// IressStack
import { StackGutter, } from './component.types';
;
const IressStack = createReactWrapper('iress-stack-24866', false, suffix);
IressStack.displayName = 'IressStack';
IressStack.Gutter = StackGutter;
export { IressStack };
// END IressStack
// IressThemeSwitcher
import { ThemeSwitcherButtonSlot, } from './component.types';
;
const IressThemeSwitcher = createReactWrapper('iress-theme-switcher-24866', false, suffix);
IressThemeSwitcher.displayName = 'IressThemeSwitcher';
IressThemeSwitcher.Slot = ThemeSwitcherButtonSlot;
export { IressThemeSwitcher };
// END IressThemeSwitcher
// IressPlaceholder
const IressPlaceholder = createReactWrapper('iress-placeholder-24866', true, suffix);
IressPlaceholder.displayName = 'IressPlaceholder';
export { IressPlaceholder };
// END IressPlaceholder
// IressBackdrop
const IressBackdrop = createReactWrapper('iress-backdrop-24866', false, suffix);
IressBackdrop.displayName = 'IressBackdrop';
export { IressBackdrop };
// END IressBackdrop
// IressModal
import { ModalSize, ModalSlot, } from './component.types';
;
const IressModal = createReactWrapper('iress-modal-24866', false, suffix);
IressModal.displayName = 'IressModal';
IressModal.Padding = PaddingSize;
IressModal.Size = ModalSize;
IressModal.Slot = ModalSlot;
export { IressModal };
// END IressModal
// IressCard
import { CardSlot, } from './component.types';
;
const IressCard = createReactWrapper('iress-card-24866', false, suffix);
IressCard.displayName = 'IressCard';
IressCard.Padding = PaddingSize;
IressCard.Slot = CardSlot;
IressCard.HeadingLevel = HeadingLevel;
export { IressCard };
// END IressCard
// IressLabel
const IressLabel = createReactWrapper('iress-label-24866', false, suffix);
IressLabel.displayName = 'IressLabel';
export { IressLabel };
;
const IressTooltip = createReactWrapper('iress-tooltip-24866', false, suffix);
IressTooltip.displayName = 'IressTooltip';
IressTooltip.Align = PopperAlign;
export { IressTooltip };
// END IressTooltip
// IressTag
const IressTag = createReactWrapper('iress-tag-24866', false, suffix);
IressTag.displayName = 'IressTag';
export { IressTag };
// END IressTag
export * from './component.types';
export * from './interfaces';
//# sourceMappingURL=index.js.map